import 'app/styles/styles.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Prompt, Route, Switch } from 'react-router-dom';
import { shouldNavigate } from 'app/app.router.navigation-handling';
import AuthProvider from 'app/blocks/common/providers/AuthProvider';
import ErrorBoundary from 'app/blocks/error-boundary';
import { renderMenu } from 'app/blocks/menu/__renderer/menu__renderer';
import { parseUrlParams } from 'app/blocks/middleware/url-params';
import PageFooter from 'app/blocks/page/__footer/page__footer';
import { setHistory } from 'app/route/history';
import routes from 'app/route/routes';

function HistoryRouter(props) {
    React.useEffect(() => setHistory(props.history), [props.history]);

    parseUrlParams(props.location);

    return <Prompt message="turn on getUserConfirmation handling" when />;
}

function App() {
    return (
        <ErrorBoundary>
            <HashRouter
                getUserConfirmation={async (message, callback) => callback(await shouldNavigate())}
                hashType="noslash"
            >
                <Route component={HistoryRouter} />
                <Switch>{routes}</Switch>
            </HashRouter>
        </ErrorBoundary>
    );
}

function render() {
    ReactDOM.render(
        <AuthProvider>
            {renderMenu()}
            <App />
            {ReactDOM.createPortal(<PageFooter />, document.getElementById('AS__footer'))}
            {ReactDOM.createPortal(<template id="as__info" />, document.getElementById('AS__info'))}
        </AuthProvider>,
        document.getElementById('content'),
    );
}

export { render };
